import React from 'react';
import ThemeProvider from "../constants/theme/ThemeProvider";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * HOC to wrap a target component with a ThemeProvider without resetting CSS
 *
 * @param Component Target component to render within Provider
 * @param partialTheme Partial theme object to merge with base theme
 */
export function withTheme(Component, partialTheme) {
  if (partialTheme === void 0) {
    partialTheme = {};
  }
  var WrappedComponent = props =>
  // @ts-ignore Prevent warning related to custom theme declarations
  ___EmotionJSX(ThemeProvider, {
    resetCSS: false,
    partialTheme: partialTheme
  }, ___EmotionJSX(Component, props));
  var name = Component.displayName || Component.name;
  WrappedComponent.displayName = "withTheme" + name;
  return WrappedComponent;
}
export default withTheme;